import Modal from '@/components/Modal';
import FrequencyHelper from '@/components/buy-stack/FrequencyHelper';
import ComponentToggleSignal from '@/components/component-toggle-signal';
import {getProductSelection} from '@/product/product-selection';
import PackOptionSelectorBox from './PackOptionSelectorBox';
import PlanOptionSelectorBox from './PlanOptionSelectorBox';
import SocialProof from '../social-proof/SocialProof';
import socialProofGenerator from '../social-proof/social-proof-generator';
import {useRef} from 'preact/hooks';
import {getColorStyle} from '@/utilities/color-style-map';

export default DeliverySelector;

function DeliverySelector({
  formatMoneyWithDecimals = false,
  showSocialProof = false,
}: DeliverySelectorProps) {
  const {product, selectedVariant} = getProductSelection();

  const frequencyHelperModal = new ComponentToggleSignal();

  const messages = useRef(
    socialProofGenerator({
      maxTimeout: 20000,
      minTimeout: 10000,
    })
  );

  const colorStyle = selectedVariant?.accentColor
    ? getColorStyle(selectedVariant.accentColor)
    : undefined;

  return (
    product &&
    selectedVariant && (
      <>
        <div className="grid grid-cols-1 gap-y-3">
          <PackOptionSelectorBox
            formatMoneyWithDecimals={formatMoneyWithDecimals}
          />
          {showSocialProof && (
            <SocialProof colorStyle={colorStyle} messages={messages.current} />
          )}
          <PlanOptionSelectorBox
            formatMoneyWithDecimals={formatMoneyWithDecimals}
            onClickFrequencyHelper={() => frequencyHelperModal.open()}
          />
        </div>
        <Modal controller={frequencyHelperModal}>
          <div className="grid h-3/4 items-center md:h-full">
            <FrequencyHelper />
          </div>
        </Modal>
      </>
    )
  );
}

export type DeliverySelectorProps = {
  formatMoneyWithDecimals?: boolean;
  showSocialProof?: boolean;
};
